import React, { useState } from "react";
import { Modal, Input, Button, Form, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { updateNationalID } from "../../../network";
import { toastError, toastSuccess } from "../../../helpers/toasters";

function IDModal({ open, setOpen }) {
  const [form] = Form.useForm();
  const [idValue, setIdValue] = useState("");
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    form
      .validateFields()
      .then(() => {
        setLoading(true);
        const payload = {
          idNumber: idValue.trim(),
        };
        updateNationalID(
          payload,
          (res) => {
            toastSuccess(res?.message);
            setOpen(false);
            setLoading(false);
          },
          (err) => {
            toastError(err?.message || "An error occurred!");
          }
        );
      })
      .catch((err) => {
        toastError(err?.message || "An error occurred!");
      });
  };

  return (
    <Modal
      open={open}
      centered
      footer={null}
      //   onCancel={onCancel}
      maskClosable={false}
      closable={false}
      width={700}
    >
      <div
        className="d-flex flex-column"
        style={{ width: "70%", margin: "auto" }}
      >
        <Typography.Title
          level={4}
          className="text-center"
          style={{ marginBottom: 24, alignSelf: "start" }}
        >
          {t("idModal.msg")}
        </Typography.Title>

        <Form form={form} layout="vertical">
          <Form.Item
            label={
              <strong style={{ color: "#176B87" }}>{t("idModal.title")}</strong>
            }
            name="idNumber"
            // initialValue={initialValue}
            rules={[
              {
                validator: (_, val) => {
                  const v = (val ?? "").toString().trim();

                  // Check if empty
                  if (!v) {
                    return Promise.reject(new Error(t("idModal.msg")));
                  }

                  // Check if it contains only digits
                  if (!/^\d+$/.test(v)) {
                    return Promise.reject(new Error(t("idModal.numberOnly")));
                  }

                  // Check if length is exactly 14 or 15
                  if (v.length !== 14 && v.length !== 15) {
                    return Promise.reject(new Error(t("idModal.validID")));
                  }

                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input
              placeholder={t("idModal.placeholder")}
              value={idValue}
              style={{ borderRadius: "8px" }}
              onChange={(e) => {
                setIdValue(e.target.value);
                form.setFieldsValue({ idNumber: e.target.value });
              }}
              size="large"
              maxLength={15}
            />
          </Form.Item>

          <Button
            type="primary"
            onClick={handleSubmit}
            loading={loading}
            disabled={loading}
            className="w-100"
            style={{
              background: "#0db14b",
              borderColor: "#0db14b",
              borderRadius: "16px",
              maxHeight: "58px",
              fontSize: "24px",
              fontWeight: "700",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "20px",
            }}
          >
            Confirm
          </Button>
        </Form>
      </div>
    </Modal>
  );
}

export default IDModal;
